import { combineReducers } from 'redux';
import { SorayaReducer } from './SorayaReducer';


export const RootReducer = combineReducers({ 
    soraya: SorayaReducer
});
